import { ArrowDown, Crown, Sparkles, Users, Wine } from "lucide-react";

const BENEFITS = [
  {
    title: "Access till VIP-area",
    description: "Tillgång till kryssningens exklusiva VIP-område.",
    icon: Crown,
    testId: "vip-benefit-item-access",
  },
  {
    title: "Dryckespaket",
    description: "Dryckespaket ingår med ditt VIP-band.",
    icon: Wine,
    testId: "vip-benefit-item-drinks",
  },
  {
    title: "Förtur till Tatuerare",
    description: "Gå före i kön till tatueraren ombord.",
    icon: Sparkles,
    testId: "vip-benefit-item-tattoo",
  },
  {
    title: "Meet n Greet med vissa artister",
    description: "Träffa vissa av kryssningens artister.",
    icon: Users,
    testId: "vip-benefit-item-meet-greet",
  },
];

export const VipBenefitsBox = () => (
  <section
    className="w-full max-w-4xl overflow-hidden border border-[#FFD700]/40 bg-[#0A0A0A] opacity-0 shadow-[0_0_30px_rgba(255,215,0,0.1)] animate-fade-in-up animate-delay-200"
    aria-labelledby="vip-benefits-title"
    data-testid="vip-benefits-box-container"
  >
    <div className="border-b border-[#FFD700]/25 bg-[#FFD700]/[0.06] p-5 md:p-6">
      <div className="mb-3 flex flex-wrap items-center gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#FFD700] shadow-[0_0_22px_rgba(255,215,0,0.24)]">
          <Crown className="h-5 w-5 text-black" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1" data-testid="vip-benefits-header">
          <p className="mb-1 text-[11px] font-bold uppercase text-[#FFD700]">
            Exklusivt via ambassadörer
          </p>
          <h2
            id="vip-benefits-title"
            className="font-heading text-lg uppercase leading-tight text-white"
          >
            Detta ingår med VIP-band
          </h2>
        </div>
      </div>
      <p
        className="text-sm leading-relaxed text-gray-300"
        data-testid="vip-benefits-ambassador-notice"
      >
        Boka genom en av våra ambassadörer och ange deras kod nedan för att få alla
        VIP-förmåner.
      </p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4" data-testid="vip-benefits-grid">
      {BENEFITS.map(({ title, description, icon: Icon, testId }, index) => (
        <div
          key={title}
          className={`flex min-h-[118px] gap-3 p-4 md:p-5 ${
            index < 3 ? "border-b border-[#242424]" : ""
          } ${index % 2 === 0 ? "sm:border-r sm:border-[#242424]" : ""} ${
            index === 2 ? "sm:border-b-0" : ""
          } ${index < 3 ? "lg:border-r lg:border-b-0 lg:border-[#242424]" : ""}`}
          data-testid={testId}
        >
          <div className="flex h-9 w-9 shrink-0 items-center justify-center border border-[#FFD700]/35 bg-[#FFD700]/10">
            <Icon className="h-4 w-4 text-[#FFD700]" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <h3 className="mb-1 text-sm font-bold text-white">{title}</h3>
            <p className="text-xs leading-relaxed text-gray-400">{description}</p>
          </div>
        </div>
      ))}
    </div>

    <div className="flex items-center justify-center gap-2 border-t border-[#FFD700]/20 bg-[#FFD700]/[0.04] px-4 py-3 text-[#FFD700]">
      <ArrowDown className="h-4 w-4 animate-bounce" aria-hidden="true" />
      <p className="text-xs font-bold uppercase" data-testid="vip-benefits-form-prompt">
        Ange din ambassadörskod nedan
      </p>
    </div>
  </section>
);